/**
 * @module "model/template.compare.model"
 */

define('formkit/model/template.compare.model',['require','exports','module','./base.model','./template.model'],function(require, exports, module) {
  //prettier-ignore
  var BaseModel     = require('./base.model'),
      TemplateModel = require('./template.model');

  /**
   * @class TemplateCompareModel
   * @augments BaseModel
   * @see {@link model/base.model.js}
   * @property {Object} childModels - and object containing a base TemplateModel
   * and a driver TemplateModel
   */

  var TemplateCompareModel = BaseModel.extend({
    /**
     * @method defaults
     *
     * @returns {Object}  an object with default base and drivers
     */
    defaults: function() {
      return {
        base: {},
        driver: {},
      };
    },

    childModels: {
      base: TemplateModel,
      driver: TemplateModel,
    },
  });
  module.exports = TemplateCompareModel;
});

